/** @typedef { 'PickedUp' | 'NotPickUp' | 'ReturnOrExchange' | 'Reset' | 'CombineToReset' | 'WaitToReset' | 'Unredeemed' } RewardRedeemStatus */
/**
 * @type {Record<RewardRedeemStatus, number>}
 * @description 店鋪會員分類
 */
export const REWARDREDEEM_STATUSE = Object.freeze({
    PickedUp: 1, // 已簽收
    NotPickUp: 2, // 未簽收
    ReturnOrExchange: 3, // 退換貨處理中
    Reset: 4, // 點數重置
    CombineToReset: 5, // 合併重置
    WaitToReset: 6, // 點數即將到期
    Unredeemed: 7, // 不兌換
});

/** @typedef {"MEMBERCARRIER" | "MOBILEBARCODE" | "CITIZENDIGITALCERTIFICATE" | "SMSSENT" } InvoiceCarrierTypeKey */
/**
 * @type {Record<InvoiceCarrierTypeKey, number>}
 * @description 發票載具類型
 */
// 發票載具類型
export const INVOICE_CARRIER_TYPE = Object.freeze({
	MEMBERCARRIER            : 1,   // 會員載具
	MOBILEBARCODE            : 2,   // 手機條碼載具
	CITIZENDIGITALCERTIFICATE: 3,   // 自然人憑證條碼載具
	SMSSENT                  : 4    // 簡訊寄送
});

/** @typedef {"DONATE" | "DUPLICATEUNIFORMINVOICE" | "TRIPLICATEUNIFORMINVOICE" | "MANUAL" } OrderInvoiceIssuingTypeKey */
/**
 * @type {Record<OrderInvoiceIssuingTypeKey, number>}
 * @description 訂單發票開立方式
 */
// 訂單發票開立方式
export const ORDER_INVOICE_ISSUING_TYPE = Object.freeze({
    DONATE                  : 1,   // 捐贈發票
    DUPLICATEUNIFORMINVOICE : 2,   // 二聯式發票
    TRIPLICATEUNIFORMINVOICE: 3,   // 三聯式發票
    MANUAL                  : 4,   // 手開發票
});

/** @typedef {'CREDITCARDVALIDORDER' | 'ANNUALEFFECTIVEORDER' | 'PAUSEORDER' | 'UNSUBSCRIBEORDER' | 'MOVEOUTORDER' | 'DRAFT' | 'NOTASSIGNORDER' | 'ALL'} CycleOrderType */
/**
* @type {Record<CycleOrderType, number>}
* @description 循環訂單類型
*/
export const CYCLEORDER_TYPE = Object.freeze({
    CREDITCARDVALIDORDER: 1,   //信用卡有效訂單
    ANNUALEFFECTIVEORDER: 2,   //年繳有效訂單
    PAUSEORDER          : 3,   //暫停訂單
    UNSUBSCRIBEORDER    : 4,   //退訂訂單
    MOVEOUTORDER        : 5,   //移出訂單
    DRAFT               : 8,   //草稿
    NOTASSIGNORDER      : 9,   //未歸類訂單
    ALL                 : 99   //全部
 });


 /** @typedef {'MONTHLY' | 'ENTERPRISE' | 'OTHERS' | 'CONTRACT' | 'PRIVATECOACH'} PromotionPlanType */
/**
* @type {Record<PromotionPlanType, number>}
* @description 優惠方案類型
*/
export const PROMOTIONPLAN_TYPE = Object.freeze({
    MONTHLY: 1,   //當月促銷
    ENTERPRISE: 2,   //企業員工優惠
    OTHERS: 3,   //其他優惠專案
    CONTRACT: 4,   //合約優惠
    PRIVATECOACH: 5,   //i私教優惠
 });

  /** @typedef {'NONE' | 'BEFORE_MEMBERSHIP' | 'AFTER_MEMBERSHIP' | 'BEFORE_SUBSCRIPTION'} PromotionPlanFreeType */
/**
* @type {Record<PromotionPlanFreeType, number>}
* @description 行銷方案贈送類型
*/
export const PROMOTIONPLAN_FREE_TYPE = Object.freeze({
    NONE: 0,   //無
    BEFORE_MEMBERSHIP: 1,   //會籍前
    AFTER_MEMBERSHIP: 2,   //會籍後
    BEFORE_SUBSCRIPTION: 3,   //訂閱前
 });

/** @typedef {'INBOUND' | 'OUTBOUND' | 'ALL'} InventoryRecordTypeKey */
/**
 * @type {Record<InventoryRecordTypeKey, number>}
 * @description 庫存異動類型（對應後端 RecordType）
 */
export const INVENTORY_RECORD_TYPE = Object.freeze({
    INBOUND : 1,    // 入庫
    OUTBOUND: -1,   // 出庫
    ALL     : 99,   // 全部
});

/** @typedef {'ALL' | 'INVOICE_ALLOWANCE' | 'UNPROCESS_BY_TUI_INVOICE' | 'PROCESSING_BY_TUI_INVOICE' | 'UNCONFIRM_BY_TUI_INVOICE'} AllowanceStatusKey */
/**
 * @type {Record<AllowanceStatusKey, number>}
 * @description 三聯式發票折讓總覽 AllowanceStatus（對應 OrderIntegrateStatusEnum / TriplicateAllowancePaginationRequestModel.AllowanceStatus）
 */
export const ALLOWANCE_STATUS = Object.freeze({
    ALL                       : 99,   // 全部
    INVOICE_ALLOWANCE         : 81,   // 發票已折讓
    UNPROCESS_BY_TUI_INVOICE  : 101,  // 三聯折讓未處理
    PROCESSING_BY_TUI_INVOICE : 102,  // 三聯折讓處理中
    UNCONFIRM_BY_TUI_INVOICE  : 103,  // 待總部確認
});

/** @typedef {'CASH' | 'PERCENT' | 'PRODUCT_LIMIT'} CampaignDiscountMethodKey */
/**
 * @type {Record<CampaignDiscountMethodKey, number>}
 * @description 抵用券折扣方式（對應後端 CampaignDiscountMethodEnum，為可相加的位元旗標）
 * - 實際值只有 1 現金、2 百分比、9 現金＋限制、10 百分比＋限制
 * - 判斷是否包含某旗標要用位元運算 &（例：10 & 2 為 2 表示含百分比，9 & 2 為 0 表示不含），不可用 === 比對
 */
export const CAMPAIGN_DISCOUNT_METHOD = Object.freeze({
    CASH         : 1,   // 現金折抵
    PERCENT      : 2,   // 百分比折扣
    PRODUCT_LIMIT: 8,   // 商品限制
});
